module.exports = __webpack_public_path__ + "static/media/foto.16e35662.svg";